import api from './api'
import { API_ENDPOINTS } from '../config/api'

const carouselService = {
  create: async (data) => {
    const response = await api.post(API_ENDPOINTS.CAROUSEL.CREATE, data)
    return response.data
  },
  list: async () => {
    const response = await api.get(API_ENDPOINTS.CAROUSEL.LIST)
    return response.data
  },
  update: async (carouselId, data) => {
    const response = await api.put(`${API_ENDPOINTS.CAROUSEL.UPDATE}/${carouselId}`, data)
    return response.data
  },
  reorder: async (order) => {
    const response = await api.put(API_ENDPOINTS.CAROUSEL.REORDER, { order })
    return response.data
  },
  remove: async (carouselId) => {
    const response = await api.delete(`${API_ENDPOINTS.CAROUSEL.DELETE}/${carouselId}`)
    return response.data
  },
  syncStatus: async () => {
    const response = await api.get(API_ENDPOINTS.BANNER_SYNC.STATUS)
    return response.data
  },
  // A live read launches Chrome through the proxy (~15-60 s), well past the
  // client's default 10 s timeout.
  syncNow: async () => {
    const response = await api.post(API_ENDPOINTS.BANNER_SYNC.RUN, {}, { timeout: 180000 })
    return response.data
  },
}

export default carouselService
